/** Neutral styling shared by folder surfaces (icon tile, drag-over ring). */
export const FOLDER_STYLE = {
  icon: "text-foreground-tertiary",
  surface: "bg-surface-hover",
  ring: "ring-border-strong",
};
